<template>
  <div>
      {{sLabel ==='' ? `Etiqueta` : sLabel}}
  </div>
</template>

<script>
import mixin from '@/mixins/BuildCorreoComponentes.js'
  export default {
    name:"Label",
    mixins:[mixin],
    data() {
      return {
      }
    },
  }
</script>

<style lang="scss" scoped>

</style>